import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import FormDialog from 'components/FormDialog';
import AdminRecurringOrderForm from './AdminRecurringOrderForm';
import { processRecurringOrderReset } from './helpers';
import RecurringOrderUpdateOrdersDialog from 'components/RecurringOrder/RecurringOrderUpdateOrdersDialog';

export default function AdminRecurringOrderEditButton({
  title,
  mode = 'add',
  item,
  onUpdate,
  open: inOpen = false,
  exitConfirm = false,
}) {
  const [openRecurringOrderForm, setOpenRecurringOrderForm] = useState(inOpen);
  const [editItem, setEditItem] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [editMode, setEditMode] = useState('group');
  const [toCreateOrders, setToCreateOrders] = useState([]);
  const [toCancelOrdersByServiceEventInfo, setToCancelOrdersByServiceEventInfo] = useState([]);
  const [elders, setElders] = useState([]);
  const [toCreateRecurringOrder, setToCreateRecurringOrder] = useState();
  const [toUpdateRecurringOrder, setToUpdateRecurringOrder] = useState();
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [toCancelOrders, setToCancelOrders] = useState([]);

  const handleButtonClick = (event) => {
    if (mode === 'add') {
      setAnchorEl(event.currentTarget);
    } else {
      if (item.elderId) {
        setEditMode('single');
      } else {
        setEditMode('group');
      }
      setOpenRecurringOrderForm(true);
      setEditItem(item);
    }
  };

  const handleResetButtonClick = async () => {
    const { toCreateOrders, ordersUncancelled, elders, toCreateRecurringOrder } = await processRecurringOrderReset(item);
    setToCancelOrders(ordersUncancelled);
    setToCreateOrders(toCreateOrders.filter((order) => order.deliveryDatetimes.length !== 0 || order.skippedDatetimes.length !== 0));
    setElders(elders);
    setToUpdateRecurringOrder(toCreateRecurringOrder);
    setOpenConfirmDialog(true);
  };

  const handleMenuClick = (editMode) => () => {
    if (!openRecurringOrderForm) {
      setEditMode(editMode);
      setOpenRecurringOrderForm(true);
      setEditItem(item);
    }
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      { mode === 'edit'?
        <Grid container direction='row'>
          {item?.status === '使用中' &&
          <Grid xs={6} item>
            <Tooltip title='重置訂單'>
              <IconButton
                aria-label={'reset'}
                size={'small'}
                onClick={handleResetButtonClick}
              >
                <SettingsBackupRestoreIcon />
              </IconButton>
            </Tooltip>
          </Grid>}
          <Grid xs={6} item>
            <Tooltip title='修改資料'>
              <IconButton
                aria-label={mode}
                size={'small'}
                onClick={handleButtonClick}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid> :
        <Tooltip title='新增資料'>
          <IconButton
            aria-label={mode}
            size={'small'}
            onClick={handleButtonClick}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      }
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <MenuItem onClick={handleMenuClick('group')}>新增送餐群組週期性排單</MenuItem>
        <MenuItem onClick={handleMenuClick('single')}>新增單一送餐對象週期性排單</MenuItem>
      </Menu>
      {openRecurringOrderForm &&
        <FormDialog
          title={title}
          openOnInit={true}
          onClose={() => {
            setOpenRecurringOrderForm(false);
            setEditItem();
          }}
          exitConfirm={exitConfirm}
        >
          <AdminRecurringOrderForm
            formData={editItem}
            onComplete={(data) => {
              if (mode === 'add') {
                const { toCreateOrders, elders, toCreateRecurringOrder, toCancelOrdersByServiceEventInfo } = data;
                setToCreateOrders(toCreateOrders);
                setToCancelOrdersByServiceEventInfo(toCancelOrdersByServiceEventInfo);
                setElders(elders);
                setToCreateRecurringOrder(toCreateRecurringOrder);
                setOpenConfirmDialog(true);
              } else {
                let message = '請注意，更改週期性排單設定不會影響30天內已新增的訂單，是否要立即重新產出30天內的訂單？';
                if (data.status === '已停用' && item?.status === '使用中') {
                  message = '請注意，停用週期性排單設定不會影響30天內已新增的訂單，是否要取消30天內的訂單？';
                }
                setOpenRecurringOrderForm(false);
                setEditItem();
                onUpdate && onUpdate(data);
                if (data.status === '使用中' || item?.status === '使用中') {
                  if (window.confirm(message)) {
                    handleResetButtonClick();
                  }
                }
              }
            }}
            editMode={editMode}
            mode={mode}
          />
        </FormDialog>}
      {openConfirmDialog &&
        <RecurringOrderUpdateOrdersDialog
          open={openConfirmDialog}
          title={'訂單列表'}
          toCreateOrders={toCreateOrders}
          toCancelOrders={toCancelOrders}
          toCancelOrdersByServiceEventInfo={toCancelOrdersByServiceEventInfo}
          elders={elders}
          toCreateRecurringOrder={toCreateRecurringOrder}
          toUpdateRecurringOrder={toUpdateRecurringOrder}
          onCancel={() => {
            setOpenConfirmDialog(false);
          }}
          onUpdate={(recurringOrder) => {
            setOpenConfirmDialog(false);
            onUpdate && onUpdate(recurringOrder);
            setOpenRecurringOrderForm(false);
          }}
          setToCreateOrders={setToCreateOrders}
        />
      }
    </React.Fragment>
  );
}

AdminRecurringOrderEditButton.propTypes = {
  title: PropTypes.string,
  mode: PropTypes.string,
  item: PropTypes.object,
  onUpdate: PropTypes.func,
  open: PropTypes.bool,
  exitConfirm: PropTypes.bool,
};
